<template>
  <v-main class="login-bg">
    <v-container fluid fill-height class="pa-0">
      <v-row no-gutters class="fill-height">

        <!-- LEFT BRAND PANEL -->
        <v-col cols="12" md="5" class="login-brand-panel d-none d-md-flex flex-column align-center justify-center pa-12">
          <div class="brand-orb mb-8">
            <img src="../assets/icono.png" alt="Eduva Logo" class="brand-logo" />
          </div>
          <h1 class="white--text font-weight-black text-h3 mb-3 text-center" style="letter-spacing:-1px">Eduva FE</h1>
          <p class="white--text text-center text-body-1 mb-10" style="opacity:0.75;max-width:280px;line-height:1.6">
            Plataforma de Facturación Electrónica para empresas costarricenses
          </p>

          <div class="brand-features">
            <div v-for="f in features" :key="f.icon" class="feature-item d-flex align-center mb-4">
              <div class="feature-icon-wrap mr-3">
                <v-icon color="white" size="18">{{ f.icon }}</v-icon>
              </div>
              <span class="white--text text-body-2" style="opacity:0.85">{{ f.text }}</span>
            </div>
          </div>

          <div class="mt-auto">
            <span class="white--text caption" style="opacity:0.4">Resolución N° MH-DGT-RES-0027-2024</span>
          </div>
        </v-col>

        <!-- RIGHT FORM PANEL -->
        <v-col cols="12" md="7" class="login-form-panel d-flex align-center justify-center pa-6">
          <div class="login-card-wrapper">

            <!-- Mobile logo only -->
            <div class="d-flex d-md-none flex-column align-center mb-8">
              <v-avatar size="64" color="white" class="elevation-4 mb-3">
                <img src="../assets/icono.png" alt="Logo" />
              </v-avatar>
              <h2 class="font-weight-black text-h5" :class="$vuetify.theme.dark ? 'white--text' : 'grey--text text--darken-3'">Eduva FE</h2>
            </div>

            <!-- Greeting -->
            <div class="mb-8">
              <p class="text-caption font-weight-bold text-uppercase mb-1" style="color:#37474f;letter-spacing:2px">Bienvenido</p>
              <h2 class="font-weight-black text-h4 mb-1" :class="$vuetify.theme.dark ? 'white--text' : 'grey--text text--darken-4'" style="letter-spacing:-0.5px">
                Inicia sesión
              </h2>
              <p class="text-body-2 mb-0" :class="$vuetify.theme.dark ? 'grey--text text--lighten-1' : 'grey--text text--darken-1'">
                Ingresa tus credenciales para continuar
              </p>
            </div>

            <!-- Form -->
            <v-form ref="form" v-model="valid" @submit.prevent="log">

              <label class="login-label">Usuario / Cédula</label>
              <v-text-field
                v-model="user.cedula"
                placeholder="Ej: 100000000"
                prepend-inner-icon="mdi-account-outline"
                outlined
                dense
                color="#37474f"
                class="login-field mt-1 mb-4"
                :rules="requiredRules"
                required
                autofocus
                hide-details="auto"
              ></v-text-field>

              <label class="login-label">Contraseña</label>
              <v-text-field
                v-model="user.clave"
                placeholder="••••••••"
                prepend-inner-icon="mdi-lock-outline"
                :append-icon="show3 ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                :type="show3 ? 'text' : 'password'"
                outlined
                dense
                color="#37474f"
                class="login-field mt-1 mb-6"
                @click:append="show3 = !show3"
                :rules="requiredRules"
                required
                hide-details="auto"
              ></v-text-field>

              <v-btn
                block
                large
                depressed
                style="background-color:#37474f !important;border-radius:8px"
                dark
                class="font-weight-bold login-btn"
                :disabled="!valid"
                :loading="loading"
                @click="log()"
              >
                <v-icon left>mdi-login-variant</v-icon>
                Ingresar al Sistema
              </v-btn>

            </v-form>

            <!-- Footer -->
            <div class="text-center mt-10">
              <span class="caption" :class="$vuetify.theme.dark ? 'grey--text text--darken-1' : 'grey--text'">
                © 2025 Eduva FE · Todos los derechos reservados
              </span>
            </div>

          </div>
        </v-col>

      </v-row>
    </v-container>
    <Snackbar v-bind:text="snackText" v-bind:snackbar="snackValue" />
  </v-main>
</template>

<script>
import axios from "axios";
import Snackbar from "../components/shared/Snackbar.vue";
import { mapMutations } from "vuex";

export default {
  components: { Snackbar },
  data() {
    return {
      show3: false,
      valid: false,
      loading: false,
      snackValue: false,
      snackText: "",
      user: { cedula: "", clave: "", nombre: "" },
      requiredRules: [(v) => !!v || "Campo requerido"],
      features: [
        { icon: "mdi-receipt",                     text: "Factura Electrónica v4.4" },
        { icon: "mdi-cash-register",               text: "Punto de Venta integrado" },
        { icon: "mdi-chart-bar",                   text: "Reportes y estadísticas" },
        { icon: "mdi-shield-check",                text: "Cumplimiento Hacienda" },
      ],
    };
  },
  methods: {
    ...mapMutations(["setUser"]),
    log() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      const me = this;
      axios
        .get("/api/Usuarios/isValidUser?cedula=" + me.user.cedula + "&clave=" + me.user.clave)
        .then(function (response) {
          if (response.data) {
            me.setUser(response.data);
            me.$router.replace({ name: "Dashboard" });
          } else {
            me.snackText = "Credenciales Incorrectas";
            me.snackValue = true;
          }
        })
        .catch(function (error) {
          me.snackText = "Error al Validar Credenciales";
          me.snackValue = true;
          console.log(error);
        })
        .finally(() => { me.loading = false; });
    },
  },
};
</script>

<style scoped>
/* === BACKGROUNDS === */
.login-bg {
  min-height: 100vh;
  background: #f8fafc;
}
.theme--dark .login-bg {
  background: #0f172a;
}

/* === BRAND PANEL === */
.login-brand-panel {
  background: linear-gradient(145deg, #37474f 0%, #263238 60%, #1a2327 100%);
  position: relative;
  overflow: hidden;
  min-height: 100vh;
}
.login-brand-panel::before {
  content: '';
  position: absolute;
  width: 400px;
  height: 400px;
  border-radius: 50%;
  background: rgba(255,255,255,0.03);
  top: -100px;
  right: -100px;
}
.login-brand-panel::after {
  content: '';
  position: absolute;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  background: rgba(255,255,255,0.03);
  bottom: -80px;
  left: -80px;
}

/* === LOGO ORB === */
.brand-orb {
  width: 100px;
  height: 100px;
  border-radius: 28px;
  background: rgba(255,255,255,0.12);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255,255,255,0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
}
.brand-logo {
  width: 64px;
  height: 64px;
  object-fit: contain;
}

/* === FEATURES === */
.brand-features { width: 100%; }
.feature-item { position: relative; z-index: 1; }
.feature-icon-wrap {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(255,255,255,0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* === FORM PANEL === */
.login-form-panel {
  background: #ffffff;
}
.theme--dark .login-form-panel {
  background: #1e293b;
}

.login-card-wrapper {
  width: 100%;
  max-width: 400px;
}

/* === LABELS === */
.login-label {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #546e7a;
}
.theme--dark .login-label {
  color: #90a4ae;
}

/* === INPUTS (square) === */
.login-field >>> .v-input__slot {
  border-radius: 8px !important;
}
.login-field >>> fieldset {
  border-color: #cfd8dc !important;
}
.login-field >>> .v-input__slot:hover fieldset {
  border-color: #37474f !important;
}
.theme--dark .login-field >>> fieldset {
  border-color: rgba(255,255,255,0.15) !important;
}

/* === BUTTON === */
.login-btn {
  height: 48px !important;
  font-size: 0.9rem !important;
  letter-spacing: 0.5px;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.login-btn:hover:not([disabled]) {
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(55,71,79,0.35) !important;
}
</style>